import { Grid, Typography, Box, Paper, useMediaQuery, } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme } from '../components/themes/main_theme.js';
import Header from '../components/menu/Header.tsx';
import { useMinistries } from '../data/cms.ts';
import PhotoCarousel from '../components/PhotoCarousel.tsx';

const Ministries = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const { items: ministries } = useMinistries();
  return (
    <ThemeProvider theme={lightTheme}>
      <Header name={'MINISTRIES'} />  
      <Box mx="auto"
        px={{xs: 0, md: 2}}
        mt={4}
        mb={6}
        flex={1}
      >
        <Typography variant="h2" color="primary" mb={2} align="left">
          What We're Doing Right Now
        </Typography>
        <Typography color="text.secondary" fontSize={{xs: 16, md: 18}} mb={4} align="left">
          Our ministry is actively serving the people of Guatemala through a variety of projects and outreach. Here are some of the ways we're making a difference:
        </Typography>
        <Grid container spacing={{xs: 2, md: 4}}>
          {ministries.map((ministry, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Paper elevation={3} sx={{ p: 3, borderRadius: 5, bgcolor: 'background.paper', height: '100%' }}>
                <Typography variant="h5" color="primary" mb={1}>
                  {ministry.title}
                </Typography>
                <Typography color="text.secondary" fontSize={14}>
                  {ministry.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <PhotoCarousel />
      </Box>
    </ThemeProvider>
  );
};

export default Ministries;